export default __webpack_public_path__ + "static/media/ginger.0261b816.png";